module.exports = __webpack_public_path__ + "static/media/1POLICY5.6b270f53.jpg";